import React from 'react'
import { SITE_INFO } from '../data/siteData'
import { useVirksomhedsoplysninger } from '../hooks/useCMS'

export function FloatingCTA() {
  const { info } = useVirksomhedsoplysninger()
  const currentInfo = info || SITE_INFO

  return (
    <aside
      aria-label="Hurtig kontakt og booking"
      className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-40 flex flex-col gap-2.5 sm:gap-3 items-end pointer-events-none"
    >
      {/* Online Booking Button */}
      {currentInfo.bookingUrl && (
        <a
          href={currentInfo.bookingUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Online booking af samtale eller forløb"
          className="pointer-events-auto w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-[#7c875a] hover:bg-[#6a744c] text-[#132835] flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 active:scale-95 border border-white/40 focus:outline-none focus:ring-2 focus:ring-[#1b3a4b] focus:ring-offset-2 relative group"
        >
          <i className="fa-solid fa-calendar-check text-sm sm:text-base" aria-hidden="true" />
          <span className="sr-only">Online booking</span>
          <span
            role="tooltip"
            className="hidden sm:inline-block absolute right-full mr-3 px-2.5 py-1 text-xs font-semibold text-white bg-[#132835] rounded-md shadow-md whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none"
          >
            Online booking
          </span>
        </a>
      )}

      {/* Email Button */}
      {currentInfo.email && (
        <a
          href={`mailto:${currentInfo.email}`}
          aria-label={`Send en email til Bo Steendahl: ${currentInfo.email}`}
          className="pointer-events-auto w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-[#2c556b] hover:bg-[#1b3a4b] text-white flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 active:scale-95 border border-white/20 focus:outline-none focus:ring-2 focus:ring-[#7c875a] focus:ring-offset-2 relative group"
        >
          <i className="fa-solid fa-envelope text-sm sm:text-base" aria-hidden="true" />
          <span className="sr-only">Send en email</span>
          <span
            role="tooltip"
            className="hidden sm:inline-block absolute right-full mr-3 px-2.5 py-1 text-xs font-semibold text-white bg-[#132835] rounded-md shadow-md whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none"
          >
            {currentInfo.email}
          </span>
        </a>
      )}

      {/* Phone Button */}
      {currentInfo.phoneRaw && (
        <a
          href={`tel:${currentInfo.phoneRaw}`}
          aria-label={`Ring til Bo Steendahl: ${currentInfo.phone}`}
          className="pointer-events-auto w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-[#1b3a4b] hover:bg-[#132835] text-white flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 active:scale-95 border border-white/20 focus:outline-none focus:ring-2 focus:ring-[#7c875a] focus:ring-offset-2 relative group"
        >
          <i className="fa-solid fa-phone text-sm sm:text-base" aria-hidden="true" />
          <span className="sr-only">Ring på {currentInfo.phone}</span>
          <span
            role="tooltip"
            className="hidden sm:inline-block absolute right-full mr-3 px-2.5 py-1 text-xs font-semibold text-white bg-[#132835] rounded-md shadow-md whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none"
          >
            Ring: {currentInfo.phone}
          </span>
        </a>
      )}
    </aside>
  )
}
